import React from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { BarChart2, Upload, ChevronLeft } from 'lucide-react';

const NAV_TABS = [
  { key: 'dataSync', label: 'Data Sync', icon: Upload, path: 'dataSync' },
  { key: 'analysis', label: 'Analysis',  icon: BarChart2, path: 'analysis' },
];

/**
 * Shared layout shell for all CRM Analysis pages.
 * Renders the top nav bar (tenant name + tab switcher) and wraps children.
 */
export default function CrmAnalysisLayout({ children, tenantName, tenantId }) {
  const navigate  = useNavigate();
  const { tenantname } = useParams();
  const { pathname }   = useLocation();

  const slug       = tenantname || tenantName;
  const activeTab  = pathname.endsWith('dataSync') ? 'dataSync' : 'analysis';

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#F8F7F4' }}>

      {/* Top bar */}
      <header
        className="flex items-center justify-between px-6 py-3 border-b"
        style={{ backgroundColor: '#FFFFFF', borderColor: '#D7B472' }}
      >
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/admin/dashboard')}
            className="flex items-center gap-1 text-sm transition-colors hover:opacity-70"
            style={{ color: '#0A0A10' }}
          >
            <ChevronLeft className="w-4 h-4" />
            Dashboard
          </button>
          <span style={{ color: '#D7B472' }}>|</span>
          <span className="font-semibold text-sm" style={{ color: '#0A0A10' }}>
            CRM Analysis
          </span>
          {slug && (
            <>
              <span style={{ color: '#D7B472' }}>·</span>
              <span
                className="text-xs px-2 py-0.5 rounded-full font-medium"
                style={{ backgroundColor: 'rgba(215,180,114,0.15)', color: '#8B6914' }}
              >
                {slug}
              </span>
            </>
          )}
        </div>

        {/* Tab switcher */}
        <nav className="flex items-center gap-1 rounded-lg p-1" style={{ backgroundColor: '#F8F7F4' }}>
          {NAV_TABS.map(({ key, label, icon: Icon, path }) => (
            <button
              key={key}
              onClick={() => navigate(`/crmanalysis/${slug}/${path}`, { state: { tenantId, tenantName: slug } })}
              className="flex items-center gap-1.5 px-4 py-1.5 rounded-md text-sm font-medium transition-all"
              style={
                activeTab === key
                  ? { backgroundColor: '#D7B472', color: '#FFFFFF', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }
                  : { color: '#0A0A10', opacity: 0.6 }
              }
            >
              <Icon className="w-3.5 h-3.5" />
              {label}
            </button>
          ))}
        </nav>
      </header>

      {/* Page content */}
      <main className="flex-1 overflow-hidden">
        {children}
      </main>
    </div>
  );
}
